import * as bus from "@sinch/bus";
import * as auth from "./auth";
import type { Token } from "./auth/types";

// Respond with most current token on Token Requests™.
// This will have issues with multiple tabs and windows for the same page but will due for now.
const unsub = bus.listen(() => {
  // TODO: Use local message here when everyone has upgraded to bus@^3.0.0.
  //bus.sendLocal(bus.tokenMessage(keycloak.getToken()));
  bus.sendGlobal(bus.tokenMessage(auth.getToken()));
}, bus.isTokenRequestMessage);

window.addEventListener("unload", unsub); // guess not needed actually

// Send token changes as soon as they happen..
let token = auth.getToken();
const updateToken = (newishToken: Token | null) => {
  if (newishToken?.token !== token?.token) {
    token = newishToken;
    // TODO: Use local message here when everyone has upgraded to bus@^3.0.0.
    //bus.sendLocal(bus.tokenMessage(token));
    bus.sendGlobal(bus.tokenMessage(token));
  }
};

const unsubscribe = auth.onTokenUpdate(updateToken);

// not really needed in this solution but good to have for future refactors
window.addEventListener("unload", unsubscribe);
